import { render, staticRenderFns } from "./SearchIdentifier.vue?vue&type=template&id=edf703e4&"
import script from "./SearchIdentifier.vue?vue&type=script&lang=js&"
export * from "./SearchIdentifier.vue?vue&type=script&lang=js&"
import style0 from "./SearchIdentifier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports